import { computed } from 'vue'
import Misc from 'src/utils/helper/misc'
import { useFetchCMS } from 'src/composables/useFetchCMS'
import { useStore } from 'vuex'
import * as Common from 'src/utils/constants/common'
import DOMPurify from 'dompurify';
import { MdButton } from '@antiqua-dls/vue-components'

export default{

  components: {
    MdButton
  },
  setup(){
    const store = useStore()
    const { data, loading, error, cmsConfig, getCmsData } = useFetchCMS()
    const sanitizeUrl = (url) => {
      return DOMPurify.sanitize(url)
    }
    const getCompleteURL = (url, dimension) => `${cmsConfig.domainURL}cdn-cgi/image/width=${dimension.width},height=${dimension.height},fit=contain,format=auto${url}`
    const content = computed(() => data?.value?.data?.resource_contents[0])
    const contentTitle = computed(() => Misc.truncate(content.value.title, 25))
    const ufda2Status = computed(() => store.getters['dashboard/getUfda2Status'])
    const bgImage = computed(() => getCompleteURL(content.value.image.image, Common.CMS_IMAGE_DIMENSIONS.merchandising_image))
    const anchorTarget = computed(() => ufda2Status.value ? '_blank' : null)
    const learnMoreDataQaId = computed(() => ufda2Status.value ? 'merchendising-tips-learn-more-enable' : 'merchendising-tips-learn-more-disabled')
    const contentUrl = (url) => ufda2Status.value ? sanitizeUrl(url) : null
    getCmsData(cmsConfig.merchendisingTips)

    return{
      data,
      loading,
      error,
      getCompleteURL,
      bgImage,
      contentTitle,
      content,
      ufda2Status,
      contentUrl,
      anchorTarget,
      learnMoreDataQaId,
      sanitizeUrl
    }
  }
}
